import { render, staticRenderFns } from "./memberinfo.vue?vue&type=template&id=1b952e68"
import script from "./memberinfo.vue?vue&type=script&lang=js"
export * from "./memberinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports